import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import { User, CreateUserDto, UpdateUserDto, ValidateResponse } from '@/types'

export const usersService = {
  getNeo: async (): Promise<User[]> => {
    return apiClient.get<User[]>(API_ENDPOINTS.USERS.NEO)
  },

  getResellers: async (): Promise<User[]> => {
    return apiClient.get<User[]>(API_ENDPOINTS.USERS.RESELLERS)
  },

  getWholesalers: async (): Promise<User[]> => {
    return apiClient.get<User[]>(API_ENDPOINTS.USERS.WHOLESALERS)
  },

  getAttachedResellers: async (params?: { wholesaler?: string }): Promise<User[]> => {
    return apiClient.get<User[]>(API_ENDPOINTS.USERS.ATTACHED_RESELLERS, {
      params: params?.wholesaler ? { wholesaler: params.wholesaler } : undefined,
    })
  },

  getCurrent: async (): Promise<User> => {
    return apiClient.get<User>(API_ENDPOINTS.USERS.CURRENT)
  },

  getById: async (id: string): Promise<User> => {
    return apiClient.get<User>(API_ENDPOINTS.USERS.BY_ID(id))
  },

  create: async (data: CreateUserDto): Promise<User> => {
    return apiClient.post<User>(API_ENDPOINTS.USERS.BASE, data)
  },

  update: async (id: string, data: UpdateUserDto): Promise<User> => {
    return apiClient.patch<User>(API_ENDPOINTS.USERS.BY_ID(id), data)
  },

  updateCurrent: async (data: UpdateUserDto): Promise<User> => {
    return apiClient.patch<User>(API_ENDPOINTS.USERS.UPDATE_CURRENT, data)
  },

  delete: async (id: string): Promise<void> => {
    return apiClient.delete<void>(API_ENDPOINTS.USERS.BY_ID(id))
  },

  verifyPassword: async (password: string): Promise<boolean> => {
    return apiClient.post<boolean>(API_ENDPOINTS.USERS.VERIFY_PASSWORD, { password })
  },

  impersonate: async (userId: string): Promise<ValidateResponse> => {
    return apiClient.post<ValidateResponse>(API_ENDPOINTS.IMPERSONATION.BY_USER_ID(userId))
  },
}
